import React, { useState } from 'react';

import EmailValidator from 'email-validator';
import { rem } from 'polished';
import styled from 'styled-components';
import { theme } from 'styled-tools';

const Form = styled.form`
  width: 100%;
  vertical-align: top;
  background-color: ${(props) => (props.inBlogPost ? theme('colors.bgLightGray') : 'rgba(0,0,0,0.2)')};
  padding: ${(props) => (props.inBlogPost ? '1.5em' : '1em')};
`;

const Title = styled.span`
  color: ${(props) => (props.inBlogPost ? theme('colors.blue') : theme('colors.white'))};
  font-size: 1.5em;
  font-weight: bold;
  line-height: 1.8em;
`;

const Response = styled.div`
  color: ${theme('colors.orange')};
`;

const Submit = styled.button`
  display: inline-block;
  color: ${(props) => (props.inBlogPost ? theme('colors.white') : theme('colors.blue'))};
  background-color: ${(props) => (props.inBlogPost ? theme('colors.altOrange') : theme('colors.white'))};
  font-size: ${rem(17)};
  font-weight: 500;
  text-transform: uppercase;
  user-select: none;
  padding: 0.5em 1em 0.5em 1em;
  transition: box-shadow 0.3s;
  cursor: pointer;
  -webkit-appearance: initial;
  border: ${(props) => (props.inBlogPost ? '0' : '1')};
  :hover {
    box-shadow: 4px 4px 0 0 ${(props) => (props.inBlogPost ? theme('colors.darkOrange') : theme('colors.altOrange'))};
  }
  :active {
    background-color: ${(props) => (props.inBlogPost ? theme('colors.darkOrange') : theme('colors.altOrange'))};
  }
  margin-top: 1em;
`;

const Input = styled.input`
  color: ${(props) => (props.inBlogPost ? 'inherit' : theme('colors.white'))};
  width: 100%;
  background-color: ${(props) => (props.inBlogPost ? theme('colors.bgLightGray') : 'rgba(0, 0, 0, 0)')};
  border: none;
  outline-width: 0;
  border-bottom: 2px solid ${(props) => (props.inBlogPost ? theme('colors.blue') : theme('colors.white'))};

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${(props) => (props.inBlogPost ? theme('colors.darkGray') : theme('colors.lightGray'))};
    opacity: 1; /* Firefox */
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${(props) => (props.inBlogPost ? theme('colors.darkGray') : theme('colors.lightGray'))};
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${(props) => (props.inBlogPost ? theme('colors.darkGray') : theme('colors.lightGray'))};
  }
`;

const NewsletterForm = ({ inBlogPost }) => {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const submitForm = (email) => {
    const portalId = process.env.HUBSPOT_PORTAL_ID;
    const formGuid = process.env.HUBSPOT_FORM_ID;

    const bodyParameters = {
      portalId,
      formGuid,
      fields: [
        {
          name: 'email',
          value: email,
        },
      ],
    };

    return fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bodyParameters),
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) {
      return;
    }

    if (!EmailValidator.validate(email)) {
      setError('Invalid email address.');
      return;
    }

    submitForm(email)
      .then((response) => {
        if (response.ok) {
          setError('');
          setSuccess('Successfully subscribed!');
          setEmail('');
        } else {
          setSuccess('');
          setError('There was an error processing the subscription!');
        }
      })
      .catch(() => {
        setSuccess('');
        setError('There was an error processing the subscription!');
      });
  };

  return (
    <Form onSubmit={handleSubmit} formNoValidate inBlogPost={inBlogPost}>
      <Title inBlogPost={inBlogPost}>Join Our Newsletter</Title>
      <div style={{ marginTop: '1em' }}>
        <Input
          type="text"
          name="email"
          placeholder="Enter your email"
          aria-label="Enter your email"
          inBlogPost={inBlogPost}
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
            setError('');
          }}
        />
      </div>
      <div>
        {!!error && <Response>{error}</Response>}
        {!!success && <Response>{success}</Response>}
      </div>
      <Submit inBlogPost={inBlogPost}>SIGN UP</Submit>
    </Form>
  );
};

export default React.memo(NewsletterForm);
